import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import classIconSrc from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_classes.svg';
import dropdownIconSrc from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_dropdown.svg';
import sadFaceSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_activities-sadface.svg';
import warningSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_warning.svg';
import inprogressSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_inprogress.svg';
import tickSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_tick.svg';
import calendarSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_calendar.svg';
import closeSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_cross.svg';
import backSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_back.svg';
import forwardSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_forward.svg';
import upArrowSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_up.svg';
import downArrowSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_down.svg';
import studentManagement from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_student-management.svg';
import play from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_right_solid.svg';
import sort from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_sort.svg';

import '../../styles/core.scss';
import css from './svg-icon.scss';

const SvgIcon = ({ type, active }) => {
    active = active || 'active';
    const iconClass = `${css['svg-icon']} ${css[type]} ${css[active]}`;
    let svgSrc = '';
    switch (type) {
    case 'classes':
    case 'no-classes':
        svgSrc = classIconSrc;
        break;
    case 'student-management':
        svgSrc = studentManagement;
        break;
    case 'dropdown':
        svgSrc = dropdownIconSrc;
        break;
    case 'tick':
    case 'null-checkbox-tick':
    case 'plain-checkbox-tick':
    case 'band-checkbox-tick':
    case 'accept':
    case 'checkbox':
        svgSrc = tickSvg;
        break;
    case 'warning':
        svgSrc = warningSvg;
        break;
    case 'inprogress':
        svgSrc = inprogressSvg;
        break;
    case 'no-students':
        svgSrc = sadFaceSvg;
        break;
    case 'calendar':
        svgSrc = calendarSvg;
        break;
    case 'close':
        svgSrc = closeSvg;
        break;
    case 'back':
        svgSrc = backSvg;
        break;
    case 'forward':
        svgSrc = forwardSvg;
        break;
    case 'upArrow':
        svgSrc = upArrowSvg;
        break;
    case 'downArrow':
        svgSrc = downArrowSvg;
        break;
    case 'play':
        svgSrc = play;
        break;
    case 'sort':
        svgSrc = sort;
        break;
    default:
    }
    return (
        <div className={iconClass}>
            <Isvg src={svgSrc} cacheGetRequests={false} />
        </div>
    );
};

SvgIcon.propTypes = {
    type: PropTypes.string,
    active: PropTypes.string
};

export default styleable(css)(SvgIcon);



// WEBPACK FOOTER //
// ./components/svg-icon/svg-icon.js